import { render, staticRenderFns } from "./EstadoWellboat.vue?vue&type=template&id=2c8ecca0"
import script from "./EstadoWellboat.vue?vue&type=script&lang=js"
export * from "./EstadoWellboat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports